import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { FilterCacheKey } from '@zaoblako/shared/modules/personalization/enums/filter-cache-key.enum';
import type { FilterCacheFindInterface } from '@zaoblako/shared/modules/personalization/dtos/filter-cache/filter-cache.find.dto';
import type { FilterCacheFormInterface } from '@zaoblako/shared/modules/personalization/dtos/filter-cache/filter-cache.form.dto';
import { Observable } from 'rxjs';

/** Provides CRUD operations for current authorized user cached filters */
@Injectable({
  providedIn: 'root'
})
export class FilterCacheService extends BaseService {
  protected baseUrl = '/basis/personalization/filter-cache';

  /**
   * Find one cached filter by key
   *
   * @param key Filter unique key
   *
   * @returns Observable object with found cached filter (or with "empty" filter object if cached filter not found)
   */
  public findOneByKey<T = any>(key: FilterCacheKey): Observable<FilterCacheFindInterface<T>> {
    return this.http.get<FilterCacheFindInterface<T>>(`${this.baseUrl}/${key}`);
  }

  /**
   * Save (create or update) cached filter by key
   *
   * @param key Filter unique key
   * @param body Values to cache
   *
   * @returns Observable object with saved cached filter
   */
  public save<T = any>(key: FilterCacheKey, body: FilterCacheFormInterface<T>): Observable<FilterCacheFindInterface<T>> {
    return this.http.post<FilterCacheFindInterface<T>>(`${this.baseUrl}/${key}`, body);
  }

  /**
   * Delete one cached filter by key
   *
   * @param key Filter unique key
   */
  public deleteOneByKey(key: FilterCacheKey): Observable<null> {
    return this.http.delete<null>(`${this.baseUrl}/${key}`);
  }

  /** Delete all cached filters for current authorized user */
  public clear(): Observable<null> {
    return this.http.delete<null>(this.baseUrl);
  }
}
